import React from "react";

export default function DrawTextComponent({ message }) {
  return <span>{message.message}</span>;
}
